import type * as state from '../../../../../../../../state'

export interface State<> {
  readonly chartId?: state.mosaic.treeEditor.models.Chart.Id
}
export namespace State {
  export const INITIAL: Readonly<State> = {}
}
